import Character from "../character/Character";
import Sprite from "../sprite/Sprite";
import SpriteAnimation from "../sprite/SpriteAnimation";
import Effect from "./Effect";
import { EffectType } from "./EffectType";

/**
 * @abstract
 */
export default class SpriteEffect extends Effect {
    constructor() {
        super();

        /**
         * @type {SpriteAnimation}
         */
        this.spriteAnimation = null;

        // /**
        //  * @type {LightSource}
        //  */
        // this.lightSource = null;
    
    }

    /**
     * @param {Character} effectOwner
     * @param {SpriteAnimation} spriteAnimation
     */
    set(effectOwner, spriteAnimation) {
        super.set(effectOwner)

        ///this.soundEffect = soundEvent;
        // this.lightSource = lightSource;
        this.spriteAnimation = spriteAnimation;

        // this.effectStatus = EffectStatus.NOT_STARTED;
        // this.startTime = Date.now();
    }

    // /**
    //  * @returns {LightSource}
    //  */
    // getLightSource() {
    //     return this.lightSource;
    // }

    /**
     * @returns {number}
     */
    getEffectType() {
        return EffectType.SPRITE_EFFECT; // <-- the vast majority will be sprite effects
    }

    // /**
    //  * @returns {Character}
    //  */
    // getEffectOwner() {
    //     return this.effectOwner;
    // }

    /**
     * @override
     * @returns {Sprite}
     */
    getSprite() {
        return this.spriteAnimation.getSpriteAsOf(Date.now(), this.startTime);
    }

    // /**
    //  * @abstract
    //  * @returns {Vector}
    //  */
    // getPosition() {
    //     return null;
    // }

    // /**
    //  * @returns {boolean}
    //  */
    // isEffectStarted() {
    //     return this.effectStatus === EffectStatus.STARTED_NOT_FINISHED;
    // }

    // /**
    //  * @returns {boolean}
    //  */
    // isNotStarted() {
    //     return this.effectStatus === EffectStatus.NOT_STARTED;
    // }

    // /**
    //  * @returns {boolean}
    //  */
    // isEffectFinished() {
    //     return this.effectStatus === EffectStatus.FINISHED_AND_AVAILABLE_FOR_CACHE
    //             || this.effectStatus === EffectStatus.FINISHED_BUT_IN_USE;
    // }

    // markEffectAsFinishedButInUse() {
    //     // If we are already 'finished and available', don't downgrade to 'finished but in use'
    //     if (this.effectStatus === EffectStatus.FINISHED_AND_AVAILABLE_FOR_CACHE) {
    //         return;
    //     }
    //     this.effectStatus = EffectStatus.FINISHED_BUT_IN_USE;

    //     // We are done with the light source by this point.
    //     if (this.lightSource != null) {
    //         this.lightSource.reset(true);
    //         this.lightSource = null;
    //     }
    // }

    // /**
    //  * @param {number} frameTimeRatio 
    //  */
    // updateEffectForFrame(frameTimeRatio) {
    //     // If we are done, then cleanup.
    //     if (this.isEffectFinished()) {
    //         //this.removeDynamicLightSourceOnFinish(lightingCalculator);
    //         return;
    //     }

    //     // See if we need to update the light source tile.
    //     // if (this.lightSource) {
    //     //     const tile = this.lightSource.getTile();
    //     //     const position = this.getPosition();
    //     //     if (tile && !tile.contains(position)) {
    //     //         this.lightSource.setTile(tile.getNeighbor(position));
    //     //     }
    //     // }

    //     // See if we are just starting the effect.
    //     if (this.effectStatus === EffectStatus.NOT_STARTED) {
    //         this.startTime = Date.now();

    //         // if (this.lightSource) {
    //         //     lightingCalculator.addDynamicLightSource(this.lightSource);
    //         // }
    //     }

    //     this.effectStatus = EffectStatus.STARTED_NOT_FINISHED;

    //     this.updateEffectForFrameInternal(frameTimeRatio);
    // }

    // /**
    //  * @private
    //  * @param {LightingCalculator} lightingCalculator 
    //  */
    // removeDynamicLightSourceOnFinish(lightingCalculator) {
    //     if (this.isEffectFinished() && this.lightSource != null) {
    //         this.lightSource.reset(true);
    //         lightingCalculator.removeDynamicLightSource(this.lightSource);
    //         this.lightSource = null;
    //     }
    // }

    // /**
    //  * @param {number} frameTimeRatio 
    //  */
    // updateEffectForFrameInternal(frameTimeRatio) {        
    // }

    // /**
    //  * @returns {number}
    //  */
    // getStartTime() {
    //     return this.startTime;
    // }

    // /**
    //  * @returns {number}
    //  */
    // getEffectStatus() {
    //     return this.effectStatus;
    // }

    // /**
    //  * @param {number} frameTime 
    //  */
    // refreshStartTime(frameTime) {
    //     this.startTime = frameTime;
    // }

    /////////////////////////////////////
    // CachedInstance
    /////////////////////////////////////

    // /**
    //  * @override
    //  */
    // isFinishedAndAvailable() {
    //     return this.effectStatus == EffectStatus.FINISHED_AND_AVAILABLE_FOR_CACHE;
    // }

    // /**
    //  * @override
    //  * @param {boolean} finishedAndAvailable 
    //  */
    // reset(finishedAndAvailable) {
    //     const currentlyFinished = this.effectStatus == EffectStatus.FINISHED_AND_AVAILABLE_FOR_CACHE;
    //     if (currentlyFinished != finishedAndAvailable) {

    //         // if (this.lightSource != null) {
    //         //     // End the light source by resetting it.
    //         //     this.lightSource.reset(true);
    //         //     this.lightSource = null;
    //         // }

    //         if (finishedAndAvailable) {
    //             this.spriteAnimation = null;
    //         }

    //         this.effectStatus = finishedAndAvailable ? EffectStatus.FINISHED_AND_AVAILABLE_FOR_CACHE : EffectStatus.NOT_STARTED;
    //         this.startTime = 0;

    //         this.listener.onAvailabilityChanged(finishedAndAvailable);
    //     }
    // }

}